import React, { useState, useEffect } from "react";
import "./mentorapplication.css";
import Header from "../component/Home/Header";
import Footer from "../component/Home/Footer";
import { images, notifyDanger, notifySuccess } from "../action/customFn";
import { MdOndemandVideo } from "react-icons/md";
import MentorApplicationStepOne from "../component/MentorApplicationForm/StepOne";
import MentorApplicationStepTwo from "../component/MentorApplicationForm/StepTwo";
import MentorApplicationStepThree from "../component/MentorApplicationForm/StepThree";
import MentorApplicationStepFour from "../component/MentorApplicationForm/StepFour";
import MentorApplicationStepFive from "../component/MentorApplicationForm/StepFive";
import axios from "../axios";
import {motion} from "framer-motion";
import { convertStateToFormData } from "../component/MentorApplicationForm/convertToFormData";

const initialMentorApplicationState = {
  stepOne: {
    chosenCourseType: 'course',
  },
  stepTwo: {
    workingTitle: ''
  },
  stepThree: {
    courseCategory: ''
  },
  stepFour: {
    courseTimeCommitment: ''
  },
  coursePlan: {
    intendedLearners: {
      whatWillStudentsLearn: [],
      prerequisites: [],
      intendedAudience: []
    },
    contentDeliveryStatus: "", // live, recorded or hybrid
    courseDuration: 0, // in months
    courseContentHours: 0,
    weeklyDaySchedule: '',
    courseFee: {
      currency: '',
      amount: 0.00,
    },
    courseCommencementDate: new Date(),
    calendlyLinkOptional: '',
    courseBrochure: '',
    demoLectureURL: '',
  },
  mentor: {
    personalInformation: {
      name: '',
      gender: '',
      email: '',
      contact: '',
      country: '',
      linkedInURL: '',
    },
    qualifications: {
      educationalQualification: {
        title: "",
        supportingDocument: null
      },
      currentProfessionalRole: {
        title: '',
        resume: null
      },
      workExperience: 0, // in months
      previouslyWorkedWithLMS: '',
    }
  }
}

const MentorApplicationForm = () => {

  const [applicationState, setApplicationState] = useState(initialMentorApplicationState);
  const [stepCount, setStepCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [applicationId, setApplicationId] = useState(() => {
    // Try to get applicationId from localStorage on mount
    return localStorage.getItem('mentorApplicationId') || null;
  });

  // Store applicationId in localStorage whenever it changes
  useEffect(() => {
    if (applicationId) {
      localStorage.setItem('mentorApplicationId', applicationId);
    }
  }, [applicationId]);

  console.log(applicationState);

  async function applicationSubmit() {
    try {
      setLoading(true);
      const url = "/register/mentor-application";
      // convert state object to formdata:
      const formData = convertStateToFormData(applicationState);
      const response = await axios.post(url, formData);

      if(response.status === 201) {
        notifySuccess("Application Submitted Successfully");
        setApplicationState(initialMentorApplicationState);
        // Clear applicationId after final submission
        setApplicationId(null);
        localStorage.removeItem('mentorApplicationId');
      }

    } catch (error) {
      notifyDanger("Some error occurred")
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  function handleFormNext() {
    if(stepCount === 1) {
      if(!applicationState.stepOne.chosenCourseType) {
        notifyDanger("Please choose a course type")
      } else {
        setStepCount(2);
      }
    } else if(stepCount === 2) {
      if(!applicationState.stepTwo.workingTitle) {
        notifyDanger("Please add a title")
      } else {
        setStepCount(3);
      }
    } else if(stepCount === 3) {
      if(!applicationState.stepThree.courseCategory) {
        notifyDanger("Please choose a category")
      } else {
        setStepCount(4);
      }
    } else if(stepCount === 4) {
      if(!applicationState.stepFour.courseTimeCommitment) {
        notifyDanger("Please add the time commitment")
      } else {
        setStepCount(5);
      }
    }
  }

  return (
    <main className="mentor-app-page">
      <div className="mentor-app-header">
        <img alt="" src={images["metb-full-logo-black.svg"]} />
        {stepCount <= 4 ? 
          <p>Step {stepCount} of 4</p>
          : 
          <p>{applicationState.stepTwo.workingTitle || "Draft Working Title"}<span style={{textTransform:"capitalize", padding:"2px 7px", border:"1px solid #ccc", borderRadius:"4px", background:"oklch(96.2% 0.059 95.617)", fontSize:"13px", fontWeight:"500", marginLeft:"10px"}}>draft</span></p>
        }
      </div>
      <div style={{background:"oklch(86.72% 0.0192 282.72deg)", height:"6px", display:"flex", width:"100%"}}>
        
        <motion.div initial={{width:"0%"}} animate={{width:`${stepCount*25}%`}} style={{ background:"oklch(48.41% 0.2342 293.93deg)"}}></motion.div>
      </div>
      {
        stepCount === 1 && <MentorApplicationStepOne setApplicationState={setApplicationState} applicationPiece={applicationState.stepOne} />
      }
      {
        stepCount === 2 && <MentorApplicationStepTwo setApplicationState={setApplicationState} applicationPiece={applicationState.stepTwo} />
      }
      {
        stepCount === 3 && <MentorApplicationStepThree setApplicationState={setApplicationState} applicationPiece={applicationState.stepThree} />
      }
      {
        stepCount === 4 && <MentorApplicationStepFour setApplicationState={setApplicationState} applicationPiece={applicationState.stepFour} />
      }
      {
        stepCount === 5 && <MentorApplicationStepFive applicationSubmit={applicationSubmit} loading={loading} setApplicationState={setApplicationState} applicationPiece={applicationState.coursePlan} mentorApplicationPiece={applicationState.mentor} applicationId={applicationId} setApplicationId={setApplicationId} />
      }
      <div className="mentor-app-footer">
        {
          stepCount > 1 && <button onClick={() => { setStepCount(prev => prev === 1 ? 0 : prev - 1) }} className="neo-xnmrph-btn-blue" style={{ color: "black", border: "2px solid gray", background: "transparent" }}>Previous</button>
        }
        { stepCount <= 4 &&  <button onClick={handleFormNext} className="neo-xnmrph-btn-blue" > {stepCount === 1 ? "Start" : stepCount === 4 ? "Finish" : "Continue"}</button>}
      </div>
    </main>
  );
};

export default MentorApplicationForm;
